/* AURIQ Concierge — vanilla widget.
 * Resolves visitor identity through auriq-tracker.js before any storage fallback.
 * Streams via SSE from /apps/.../concierge/stream/<jobId>.
 */
(function () {
  "use strict";
  var cfg = window.AuriqConfig;
  if (!cfg || !cfg.proxyUrl) return;

  var KEY_VID = "auriq_vid";
  var KEY_HMAC = "auriq_vhmac";
  var TEST_SESSION_KEY = "auriq.test-session.v1";
  function storedVisitor() {
    try {
      var id = localStorage.getItem(KEY_VID);
      var h = localStorage.getItem(KEY_HMAC);
      return id && h ? { id: id, hmac: h } : null;
    } catch (e) { return null; }
  }

  function resolveVisitor() {
    var api = window.Auriq;
    if (api && typeof api.ensureGuestIdentity === "function") {
      try {
        return Promise.resolve(api.ensureGuestIdentity()).then(function (v) {
          return v && v.id && v.hmac ? { id: v.id, hmac: v.hmac } : null;
        }, function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }
    try {
      if (sessionStorage.getItem(TEST_SESSION_KEY) !== null) return Promise.resolve(null);
    } catch (e) { return Promise.resolve(null); }
    return Promise.resolve(storedVisitor());
  }

  function el(tag, css, text) {
    var e = document.createElement(tag);
    if (css) e.style.cssText = css;
    if (text != null) e.textContent = text;
    return e;
  }

  var ROOT_CSS = "position:relative!important;margin:16px auto!important;margin-bottom:calc(16px + env(safe-area-inset-bottom,0px))!important;width:340px!important;max-width:calc(100vw - 32px)!important;max-height:calc(100vh - 128px)!important;max-height:min(520px,calc(100vh - 128px - env(safe-area-inset-bottom,0px)))!important;background:#fff!important;border:1px solid #ddd!important;border-radius:10px!important;box-shadow:0 8px 24px rgba(0,0,0,.12)!important;font-family:Georgia,serif!important;color:#111!important;z-index:auto!important;display:flex!important;flex-direction:column!important;overflow:hidden!important;";
  var HEADER_CSS = "padding:12px 14px!important;border-bottom:1px solid #eee!important;font-weight:600!important;font-size:14px!important;color:#111!important;background:#fff!important;display:flex!important;justify-content:space-between!important;align-items:center!important;letter-spacing:0.06em!important;";
  var BODY_CSS = "flex:1!important;overflow-y:auto!important;padding:12px 14px!important;font-size:13px!important;line-height:1.5!important;color:#222!important;background:#fff!important;";
  var INTRO_CSS = "color:#555!important;font-size:12px!important;margin-bottom:8px!important;font-style:italic!important;";
  var FOOTER_CSS = "border-top:1px solid #eee!important;padding:8px!important;display:flex!important;gap:6px!important;background:#fff!important;";
  var INPUT_CSS = "flex:1!important;min-width:0!important;min-height:44px!important;padding:8px 10px!important;border:1px solid #ccc!important;border-radius:4px!important;font:16px/1.4 system-ui,sans-serif!important;background:#fff!important;color:#111!important;outline:none!important;box-shadow:none!important;";
  var BTN_CSS = "min-height:44px!important;padding:8px 14px!important;border:1px solid #222!important;background:#222!important;color:#fff!important;border-radius:4px!important;cursor:pointer!important;font:inherit!important;font-weight:500!important;";
  var CLOSE_BTN_CSS = "min-width:44px!important;min-height:44px!important;background:none!important;border:none!important;font-size:20px!important;line-height:1!important;color:#666!important;cursor:pointer!important;padding:0 4px!important;";
  var FAB_CSS = "position:relative!important;margin:16px auto!important;margin-bottom:calc(16px + env(safe-area-inset-bottom,0px))!important;max-width:calc(100vw - 32px)!important;min-height:44px!important;background:#C5A059!important;color:#0d0d0d!important;border:none!important;border-radius:24px!important;padding:12px 18px!important;cursor:pointer!important;font-family:Georgia,serif!important;font-size:14px!important;font-weight:600!important;box-shadow:0 4px 16px rgba(197,160,89,.45)!important;z-index:auto!important;display:block!important;visibility:visible!important;opacity:1!important;";
  var BUBBLE_USER = "display:inline-block!important;max-width:80%!important;padding:8px 12px!important;background:#222!important;color:#fff!important;border-radius:14px 14px 2px 14px!important;margin-bottom:6px!important;font-size:13px!important;line-height:1.4!important;";
  var BUBBLE_ASSIST = "display:inline-block!important;max-width:80%!important;padding:8px 12px!important;background:#f1f1f1!important;color:#222!important;border-radius:14px 14px 14px 2px!important;margin-bottom:6px!important;font-size:13px!important;line-height:1.4!important;";

  var widgetOpen = false;
  var root, bodyEl, inputEl, sendBtn;
  var availabilityRequested = false;
  var availabilityController = null;
  var proactiveTimer = null;

  function analyticsAllowed() {
    var api = window.Auriq;
    return !!(api && typeof api.analyticsConsentGranted === "function" && api.analyticsConsentGranted());
  }

  function appendBubble(role, text) {
    var row = el("div", "text-align:" + (role === "user" ? "right" : "left") + ";");
    var b = el("span", role === "user" ? BUBBLE_USER : BUBBLE_ASSIST);
    b.textContent = text;
    row.appendChild(b);
    bodyEl.appendChild(row);
    bodyEl.scrollTop = bodyEl.scrollHeight;
    return b;
  }

  // Pull the live cart from the Shopify storefront. We send the raw payload
  // to dossier; the server picks the fields it actually uses and re-formats
  // before passing to the model.
  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  // Cache a compact catalog snapshot (title/handle/price/type/tags only) in
  // sessionStorage so the model can cross-recommend without us paying for a
  // full storefront fetch on every chat turn. Refreshes when the session
  // expires (browser-defined).
  var CATALOG_KEY = "auriq_concierge_catalog";

  function compactCatalog(products) {
    if (!Array.isArray(products)) return [];
    var out = [];
    for (var i = 0; i < products.length && out.length < 50; i++) {
      var p = products[i];
      if (!p || !p.title || !p.handle) continue;
      // Shopify /products.json prices are dollar-strings; convert to cents
      // so the dossier formatter doesn't have to parse two formats.
      var priceCents = null;
      if (typeof p.price === "number") {
        priceCents = p.price;
      } else if (typeof p.price === "string") {
        var parsed = parseFloat(p.price);
        if (isFinite(parsed)) priceCents = Math.round(parsed * 100);
      } else if (p.variants && p.variants[0] && p.variants[0].price) {
        var vp = parseFloat(p.variants[0].price);
        if (isFinite(vp)) priceCents = Math.round(vp * 100);
      }
      out.push({
        title: p.title,
        handle: p.handle,
        price: priceCents,
        product_type: p.product_type || null,
        tags: Array.isArray(p.tags) ? p.tags.slice(0, 8) : (typeof p.tags === "string" ? p.tags : null)
      });
    }
    return out;
  }

  function fetchCatalog() {
    var cached;
    try { cached = sessionStorage.getItem(CATALOG_KEY); } catch (e) { cached = null; }
    if (cached) return Promise.resolve(cached);
    return fetch("/products.json?limit=50", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !Array.isArray(data.products)) return "";
        var compact = JSON.stringify(compactCatalog(data.products));
        try { sessionStorage.setItem(CATALOG_KEY, compact); } catch (e) {
          // Catalog caching is optional; the current response still serves this chat turn.
        }
        return compact;
      })
      .catch(function () { return ""; });
  }

  // On a PDP, fetch the canonical product JSON so the model has authoritative
  // variants/prices/options instead of guessing. Returns "" on collection,
  // cart, or homepage. Handle parsing matches Shopify's URL shape:
  // /products/<handle>(/...)? possibly under a locale prefix.
  function fetchProduct() {
    if ((cfg.pageType || "") !== "product") return Promise.resolve("");
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve("");
    var handle = m[1];
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .catch(function () { return ""; });
  }

  function send() {
    var text = inputEl.value.trim();
    if (!text) return;
    sendBtn.disabled = true;
    var v = null;

    resolveVisitor().then(function (resolved) {
      v = resolved;
      if (!v) throw new Error("We could not start the chat. Please try again.");
      appendBubble("user", text);
      inputEl.value = "";
      return Promise.all([fetchCart(), fetchProduct(), fetchCatalog()]);
    }).then(function (ctx) {
      var cartJson = ctx[0];
      var productJson = ctx[1];
      var catalogJson = ctx[2];
      return fetch(cfg.proxyUrl + "/concierge/start", {
        method: "POST", credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          visitor_id: v.id,
          visitor_hmac: v.hmac,
          user_message: text,
          page_url: window.location.pathname,
          page_context: cfg.pageType || "",
          cart_json: cartJson || "",
          product_json: productJson || "",
          catalog_json: catalogJson || ""
        })
      });
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.blocked_reason || !data.job_id || !data.stream_token) {
          appendBubble("assistant", "Sorry — " + humanReason(data && data.blocked_reason));
          sendBtn.disabled = false;
          return;
        }
        streamJob(data.job_id, data.stream_token);
      })
      .catch(function () {
        if (!inputEl.value) inputEl.value = text;
        appendBubble("assistant", "Connection error. Please try sending your message again.");
        sendBtn.disabled = false;
      });
  }

  function humanReason(code) {
    switch (code) {
      case "RATE_LIMIT_VISITOR":
      case "RATE_LIMIT_IP":
        return "you've hit the chat limit. Try again later.";
      case "BUDGET_EXCEEDED":
        return "the concierge is paused for the day.";
      case "ABUSE_FLAGGED":
        return "we can't continue this conversation.";
      case "INJECTION_IGNORE_PREVIOUS":
      case "INJECTION_ROLE_HIJACK":
      case "INJECTION_PROMPT_LEAK":
      case "INJECTION_TEMPLATE":
      case "INJECTION_JAILBREAK":
      case "ABUSE":
        return "that message was blocked by our safety filter.";
      default:
        return "the concierge is unavailable right now.";
    }
  }

  function streamJob(jobId, streamToken) {
    var assistBubble = appendBubble("assistant", "");
    if (!streamToken) { assistBubble.textContent = "Please refresh and try again."; sendBtn.disabled = false; return; }
    // Same-origin fetch through the App Proxy. EventSource on the proxy (and
    // on the app origin) closes in ~8ms with an empty body, so the bubble hangs.
    var url = cfg.proxyUrl + "/concierge/stream/" + encodeURIComponent(jobId)
      + "?stream_token=" + encodeURIComponent(streamToken);
    var watchdog = setTimeout(function () {
      if (!assistBubble.textContent) {
        assistBubble.textContent = "Sorry — the automated assistant didn't respond. Try again.";
      }
      sendBtn.disabled = false;
    }, 25000);
    fetch(url, { credentials: "include" })
      .then(function (r) { return r.text(); })
      .then(function (raw) {
        clearTimeout(watchdog);
        var parts = String(raw).split("\n");
        for (var i = 0; i < parts.length; i++) {
          var line = parts[i];
          if (line.indexOf("data:") !== 0) continue;
          try {
            var d = JSON.parse(line.slice(5).trim());
            if (d.text) {
              assistBubble.textContent += d.text;
              bodyEl.scrollTop = bodyEl.scrollHeight;
            }
          } catch (e) {
            // Skip one malformed stream frame and keep processing later frames.
            continue;
          }
        }
        if (!assistBubble.textContent) {
          assistBubble.textContent = "Sorry — the automated assistant is unavailable right now.";
        }
        sendBtn.disabled = false;
      })
      .catch(function () {
        clearTimeout(watchdog);
        if (!assistBubble.textContent) {
          assistBubble.textContent = "Sorry — the automated assistant is unavailable right now.";
        }
        sendBtn.disabled = false;
      });
  }

  function findOwnerHelpButton() {
    var activeCustomizer = document.querySelector(".customizer-modal.active");
    var modalButton = activeCustomizer && activeCustomizer.querySelector("[data-design-help-button]");
    if (modalButton) return modalButton;
    return document.querySelector("[data-design-help-entry] [data-design-help-button]")
      || document.querySelector("[data-design-help-button]");
  }

  function buildRoot() {
    root = el("div", ROOT_CSS);
    root.id = "auriq-concierge-window";
    var header = el("div", HEADER_CSS);
    var title = el("span", "color:#111!important;font-weight:600!important;font-size:14px!important;letter-spacing:0.08em!important;", "AURIQ DESIGN ASSISTANT");
    header.appendChild(title);
    var close = el("button", CLOSE_BTN_CSS, "×");
    close.type = "button";
    close.setAttribute("aria-label", "Close design assistant");
    close.onclick = hide;
    header.appendChild(close);
    bodyEl = el("div", BODY_CSS);
    bodyEl.appendChild(el("div", INTRO_CSS,
      "This is AURIQ's automated assistant. It can help with product and design questions."));
    var ownerHelpButton = findOwnerHelpButton();
    if (ownerHelpButton) {
      var ownerHelpCta = el("button", BTN_CSS, "Continue with the owner");
      ownerHelpCta.type = "button";
      ownerHelpCta.style.marginBottom = "10px";
      ownerHelpCta.setAttribute("data-owner-help-cta", "true");
      ownerHelpCta.onclick = function () {
        var currentHelpButton = findOwnerHelpButton();
        if (!currentHelpButton) return;
        hide();
        if (typeof currentHelpButton.scrollIntoView === "function") {
          currentHelpButton.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        currentHelpButton.click();
      };
      bodyEl.appendChild(ownerHelpCta);
    }
    var footer = el("div", FOOTER_CSS);
    inputEl = el("input", INPUT_CSS);
    inputEl.type = "text";
    inputEl.setAttribute("aria-label", "Message AURIQ automated assistant");
    inputEl.placeholder = "Type a message…";
    inputEl.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });
    sendBtn = el("button", BTN_CSS, "Send");
    sendBtn.onclick = send;
    footer.appendChild(inputEl);
    footer.appendChild(sendBtn);
    root.appendChild(header);
    root.appendChild(bodyEl);
    root.appendChild(footer);
  }

  function show() {
    if (widgetOpen) return;
    if (!root) buildRoot();
    document.body.appendChild(root);
    widgetOpen = true;
    setTimeout(function () { if (inputEl) inputEl.focus(); }, 30);
    var fab = document.getElementById("auriq-concierge-fab");
    if (fab) fab.style.display = "none";
  }
  function hide() {
    if (!widgetOpen) return;
    if (root.parentNode) root.parentNode.removeChild(root);
    widgetOpen = false;
    showFab();
  }

  function showFab() {
    var existing = document.getElementById("auriq-concierge-fab");
    if (existing) { existing.style.display = "block"; return; }
    var fab = el("button", FAB_CSS, "Ask AURIQ");
    fab.id = "auriq-concierge-fab";
    fab.type = "button";
    fab.onclick = show;
    document.body.appendChild(fab);
  }

  // ---- bootstrap on availability check (called from tracker) ---------
  window.Auriq = window.Auriq || {};
  window.Auriq.concierge = {
    init: function () {
      showFab();
      if (!analyticsAllowed() || availabilityRequested) return;
      availabilityRequested = true;
      resolveVisitor().then(function (v) {
        if (!analyticsAllowed()) { availabilityRequested = false; return null; }
        if (!v) { availabilityRequested = false; return null; }
        if (typeof window.AbortController === "function") availabilityController = new window.AbortController();
        return fetch(cfg.proxyUrl + "/concierge/availability", {
          method: "POST", credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ visitor_id: v.id, visitor_hmac: v.hmac }),
          signal: availabilityController ? availabilityController.signal : undefined
        });
      })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) return;
          showFab();
          if (data && data.mode === "proactive") proactiveTimer = setTimeout(function () {
            proactiveTimer = null;
            if (analyticsAllowed()) show();
          }, 5000);
        })
        .catch(function () { availabilityRequested = false; showFab(); });
    },
    withdraw: function () {
      if (proactiveTimer) { clearTimeout(proactiveTimer); proactiveTimer = null; }
      if (availabilityController) { availabilityController.abort(); availabilityController = null; }
      availabilityRequested = false;
    },
    open: show,
    close: hide
  };

  showFab();
  if (analyticsAllowed()) window.Auriq.concierge.init();
})();
